import { API_BASE_URL } from '../config';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function BusquedaCliente() {
    const navigate = useNavigate();
    const { loteId } = useParams();
    const [documento, setDocumento] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [clienteEncontrado, setClienteEncontrado] = useState(null);

    const buscarCliente = async () => {
		setLoading(true);
		setError(null);
		try {
			//const response = await fetch(`http://192.168.0.3:3001/api/clientes/buscar/${documento}`);
			const response = await fetch(`${API_BASE_URL}/api/clientes/buscar/${documento}`);
			const data = await response.json();
			
			if (data && data.id_cliente) {
				// Si encontramos el cliente, mostramos sus datos
				setClienteEncontrado(data);
			} else {
				// Si no encontramos el cliente, redirigimos al registro
				console.log('Cliente no encontrado, redirigiendo a registro');
				navigate(`/registro-cliente/${loteId}/${documento}`);
			}
		} catch (err) {
			setError('Error al buscar cliente');
		} finally {
			setLoading(false);
		}
	};

    const continuarVenta = () => {
        if (clienteEncontrado) {
            navigate(`/venta/${loteId}/${clienteEncontrado.id_cliente}`);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-800">Buscar Cliente</h2>
                <button 
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                    Volver
                </button>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Número de Documento
                        </label>
                        <input
                            type="text"
                            value={documento}
                            onChange={(e) => setDocumento(e.target.value)}
                            className="w-full p-2 border rounded-md"
                            placeholder="Ingrese número de documento"
                        />
                    </div>

                    {error && (
                        <div className="text-red-600 text-sm">
                            {error}
                        </div>
                    )}

                    <button
                        onClick={buscarCliente}
                        disabled={loading || !documento}
                        className="w-full bg-[#2f62ab] text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-300"
                    >
                        {loading ? 'Buscando...' : 'Buscar Cliente'}
                    </button>

                    {clienteEncontrado && (
                        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                            <h3 className="font-semibold text-lg mb-2">Cliente Encontrado:</h3>
                            <p><span className="font-medium">Nombre:</span> {clienteEncontrado.nombre_razon_social_cliente}</p>
                            <p><span className="font-medium">Documento:</span> {clienteEncontrado.nro_documento_cliente}</p>
                            <p><span className="font-medium">Teléfono:</span> {clienteEncontrado.telefono_movil_cliente}</p>
                            <p><span className="font-medium">Dirección:</span> {clienteEncontrado.direccion_cliente}</p>
                            
                            <button
                                onClick={continuarVenta}
                                className="w-full mt-4 bg-[#8fc94a] text-white py-2 px-4 rounded-md hover:bg-green-700"
                            >
                                Continuar con la Reserva
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}